import { useEffect, useRef, useState } from "react";
import { addData, deleteFileByUrl, getData, handleFireBaseUpload } from "../Firebase/firestore";
import { db } from "../firebase";
import './resources.css'
import './main.css'
import sh from '../assets/search.png'

function AddBrand() {

    const [img, setImg] = useState()
    const [loading, setLoading] = useState(false)
    const [brands, setBrands] = useState([])
    const [preview, setPreview] = useState()
    const [previewS, setPreviewS] = useState()

    const name = useRef()
    const des = useRef()

    const [search, setSearch] = useState("")

    const [editRowId, setEditRowId] = useState(null)
    const [editName, setEditName] = useState("")
    const [editDes, setEditDes] = useState("")
    const [editImgFile, setEditImgFile] = useState(null)
    const [editImgPreview, setEditImgPreview] = useState(null)
    const [editLoading, setEditLoading] = useState(false)

    const [delmodal, setDelModal] = useState({ s: false, brand: null })
    const [uploadProgress, setUploadProgress] = useState(0)
    const [uploadTotal, setUploadTotal] = useState(0)
    const [uploadStatus, setUploadStatus] = useState('')
    const [successModal, setSuccessModal] = useState(null)
    const [deletingUpload, setDeletingUpload] = useState(false)

    useEffect(() => {
        getBrands().then(() => { })
    }, [])

    useEffect(() => {
        if (img) {
            setPreview(URL.createObjectURL(img))
        } else {
            setPreview(null)
        }
    }, [img])

    const getBrands = async () => {
        const collection = db.collection("Brands")
        const data = await getData(collection)
        setBrands(data || [])
    }

    const uploadBrand = async () => {
        setUploadTotal(1)
        setUploadProgress(0)
        setLoading(true)
        try {
            setUploadStatus('Uploading brand logo...')
            const ref = 'Brands'
            const N = new Date().getTime().toString()
            const url = await handleFireBaseUpload(
                img.name + "-" + N,
                img,
                ref
            )
            setUploadProgress(1)

            setUploadStatus('Saving to database...')
            const Data = {
                "name": name.current.value,
                "des": des.current.value,
                "src": url,
                "id": N
            }

            const collection = db.collection("Brands")
            await addData(collection, null, Data)
            await getBrands()

            setSuccessModal({
                id: N,
                name: Data.name,
                des: Data.des,
                src: url,
            })

            setPreview(null)
            setImg(null)
            if (name.current) name.current.value = ''
            if (des.current) des.current.value = ''
        } catch (e) {
            console.log("error from brand", e)
            alert('Upload failed. Please try again.')
        } finally {
            setLoading(false)
            setUploadStatus('')
        }
    }

    const deleteUploadedBrand = async () => {
        if (!successModal) return
        try {
            setDeletingUpload(true)
            if (successModal.src) {
                await deleteFileByUrl(successModal.src)
            }
            const collection = db.collection('Brands')
            const snap = await collection.where('id', '==', successModal.id).get()
            await Promise.all(snap.docs.map((d) => d.ref.delete()))
            await getBrands()
            setSuccessModal(null)
        } catch (error) {
            console.log('delete uploaded brand', error)
            alert('Unable to delete the uploaded brand.')
        } finally {
            setDeletingUpload(false)
        }
    }

    const startEdit = (brand) => {
        setEditRowId(brand.id || brand.doc)
        setEditName(brand.name || "")
        setEditDes(brand.des || "")
        setEditImgFile(null)
        setEditImgPreview(brand.src || null)
        setPreviewS(null)
    }

    const cancelEdit = () => {
        setEditRowId(null)
        setEditName("")
        setEditDes("")
        setEditImgFile(null)
        setEditImgPreview(null)
        setPreviewS(null)
    }

    const handleEditImgChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            setEditImgFile(file)
            setEditImgPreview(URL.createObjectURL(file))
        }
    }

    const updateBrand = async (val) => {
        try {
            setEditLoading(true)
            const newName = (editName && editName.length > 0) ? editName : val.name
            const newDes = (editDes && editDes.length > 0) ? editDes : val.des
            const ref = 'Brands'
            let url = val.src
            if (editImgFile) {
                url = await handleFireBaseUpload(editImgFile.name, editImgFile, ref)
            }
            const Ndata = {
                "id": val.id,
                "src": url,
                "name": newName,
                "des": newDes
            }
            const collection = db.collection('Brands')
            await addData(collection, val.doc, Ndata)
            await getBrands()
            cancelEdit()
            setEditLoading(false)
        } catch (e) {
            console.log("error updating brand", e)
            setEditLoading(false)
        }
    }

    const deleteBrand = async (val) => {
        try {
            const collection = db.collection('Brands')
            await collection.doc(val.doc).delete();
            setDelModal({ s: false, brand: null })
            await getBrands()
        } catch (e) {
            console.log("error deleting brand", e)
        }
    }

    const filteredBrands = (brands || []).filter((b) => {
        if (!search) return true
        const text = JSON.stringify(b).toLowerCase()
        return text.includes(search.toLowerCase())
    })

    return (
        <div className='button_upload_page button-upload-premium-page add-brand-page'>
            <div className="button_upload_form fabric-modern button-upload-premium-form add-brand-form">
                <form
                    className="button-upload-premium-fields"
                    onSubmit={async (e) => {
                        e.preventDefault()
                        if (!img || !name.current?.value) return
                        await uploadBrand()
                    }}
                >
                    <div className="f-inputs">
                        <label className="button-upload-label">Brand Name <span className="text-red-500">*</span></label>
                        <input ref={name} type="text" placeholder="Enter brand name" />
                    </div>

                    <div className="f-inputs">
                        <label className="button-upload-label">Description</label>
                        <textarea ref={des} rows={3} placeholder="Short description about the brand" />
                    </div>

                    <div className="f-inputs">
                        <div className="fabric-file-title"><b>Brand Logo <span className="text-red-500">*</span></b></div>
                        <input
                            className="fabric-file-input"
                            type="file"
                            accept="image/*"
                            onChange={(e) => { setImg(e.target.files[0]) }}
                        />
                        {preview && (
                            <div className="button-upload-preview add-brand-preview">
                                <img src={preview} alt="Brand logo preview" />
                            </div>
                        )}
                    </div>

                    {loading ? (
                        <div className="outfit-upload-progress">
                            <div className="outfit-upload-progress-top">
                                <span>{uploadStatus || 'Uploading...'}</span>
                                <strong>{uploadTotal ? Math.floor((uploadProgress / uploadTotal) * 100) : 0}%</strong>
                            </div>
                            <div className="outfit-upload-progress-track">
                                <div
                                    className="outfit-upload-progress-fill"
                                    style={{ width: `${uploadTotal ? (uploadProgress / uploadTotal) * 100 : 0}%` }}
                                />
                            </div>
                            <div className="outfit-upload-progress-meta">
                                {uploadProgress} / {uploadTotal} files uploaded
                            </div>
                        </div>
                    ) : (
                        <button
                            type="submit"
                            className="fabric-submit-btn"
                            disabled={!img || !(name.current && name.current.value)}
                        >
                            Add Brand
                        </button>
                    )}
                </form>
            </div>

            <div className="button-upload-list-shell add-brand-list-shell">
                <h2 className="button-upload-list-title">Available Brands</h2>
                <div className="button-upload-filterbar add-brand-filterbar">
                    <span className="add-brand-count">{filteredBrands.length} brand{filteredBrands.length === 1 ? '' : 's'}</span>
                    <div className="edit-fabric-search-box button-upload-search-box">
                        <input
                            className="search_fabric_clothes"
                            placeholder="Search brand"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <img src={sh} alt="Search" />
                    </div>
                </div>

                <div className="button_uploads button-upload-list add-brand-list">
                    {filteredBrands.length === 0 ? (
                        <div className="add-brand-empty">No brands found.</div>
                    ) : (
                        filteredBrands.map((val, k) => (
                            <div className="button_upload_card button-upload-premium-card add-brand-card" key={val.id || val.doc || k}>
                                <button
                                    type="button"
                                    className="button-upload-edit-icon-btn"
                                    onClick={() => startEdit(val)}
                                    aria-label="Edit brand"
                                >
                                    ✎
                                </button>
                                <div className="button-upload-card-image-wrap add-brand-card-image-wrap">
                                    <img
                                        src={val.src}
                                        alt={val.name || 'Brand'}
                                        className="button-upload-card-image add-brand-card-image"
                                    />
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {editRowId && (() => {
                const val = brands.find((b) => (b.id || b.doc) === editRowId)
                if (!val) return null
                return (
                    <div className="recom-modal-backdrop" onClick={cancelEdit}>
                        <div className="recom-modal add-brand-edit-modal" onClick={(ev) => ev.stopPropagation()}>
                            <div className="recom-modal-header">
                                <div>
                                    <h3>Edit Brand</h3>
                                    <p>Update logo, name or description of this brand.</p>
                                </div>
                                <button type="button" className="recom-modal-close" onClick={cancelEdit} aria-label="Close">×</button>
                            </div>
                            <div className="recom-modal-body add-brand-edit-body">
                                <div className="f-inputs">
                                    <label className="button-upload-label">Brand Name</label>
                                    <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} />
                                </div>
                                <div className="f-inputs">
                                    <label className="button-upload-label">Description</label>
                                    <textarea rows={3} value={editDes} onChange={(e) => setEditDes(e.target.value)} />
                                </div>
                                <div className="f-inputs">
                                    <div className="fabric-file-title"><b>Change Logo</b></div>
                                    <input className="fabric-file-input" type="file" accept="image/*" onChange={handleEditImgChange} />
                                    {editImgPreview && (
                                        <div className="button-upload-preview add-brand-preview">
                                            <img src={editImgPreview} alt="Brand logo preview" />
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="recom-modal-footer">
                                <button
                                    type="button"
                                    className="fabric-submit-btn recom-modal-clear add-brand-delete-btn"
                                    onClick={() => setDelModal({ s: true, brand: val })}
                                    disabled={editLoading}
                                >
                                    Delete
                                </button>
                                <div className="recom-modal-actions">
                                    <button type="button" className="fabric-submit-btn recom-modal-clear" onClick={cancelEdit} disabled={editLoading}>Cancel</button>
                                    <button type="button" className="fabric-submit-btn recom-modal-done" onClick={() => updateBrand(val)} disabled={editLoading}>
                                        {editLoading ? 'Saving...' : 'Save Changes'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })()}

            {successModal && (
                <div className="outfit-success-modal-backdrop">
                    <div className="outfit-success-modal">
                        <div className="outfit-success-modal-badge">Upload Successful</div>
                        <h3>Brand added successfully</h3>
                        <div className="outfit-success-modal-grid">
                            <div><span>ID</span><strong>{successModal.id}</strong></div>
                            <div><span>Name</span><strong>{successModal.name}</strong></div>
                            {successModal.des && (
                                <div><span>Description</span><strong>{successModal.des}</strong></div>
                            )}
                        </div>
                        <button type="button" className="fabric-submit-btn outfit-success-close" onClick={() => setSuccessModal(null)}>
                            Close
                        </button>
                        <button
                            type="button"
                            className="fabric-submit-btn outfit-delete-close"
                            onClick={() => {
                                if (deletingUpload) return;
                                if (window.confirm(`Are you sure you want to delete ${successModal?.name || 'this uploaded brand'}? This action cannot be undone.`)) {
                                    deleteUploadedBrand();
                                }
                            }}
                            disabled={deletingUpload}
                        >
                            {deletingUpload ? 'Deleting...' : 'Delete This Upload'}
                        </button>
                    </div>
                </div>
            )}

            {delmodal.s && delmodal.brand && (
                <div className="recom-modal-backdrop" onClick={() => setDelModal({ s: false, brand: null })}>
                    <div className="recom-modal add-brand-delete-modal" onClick={(ev) => ev.stopPropagation()}>
                        <div className="recom-modal-header">
                            <div>
                                <h3>Delete Brand</h3>
                                <p>Are you sure you want to delete <b>{delmodal.brand.name}</b>? This action cannot be undone.</p>
                            </div>
                            <button type="button" className="recom-modal-close" onClick={() => setDelModal({ s: false, brand: null })} aria-label="Close">×</button>
                        </div>
                        <div className="recom-modal-footer">
                            <div></div>
                            <div className="recom-modal-actions">
                                <button type="button" className="fabric-submit-btn recom-modal-clear" onClick={() => setDelModal({ s: false, brand: null })}>Cancel</button>
                                <button type="button" className="fabric-submit-btn recom-modal-done add-brand-confirm-delete" onClick={() => deleteBrand(delmodal.brand)}>
                                    Confirm Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AddBrand;